import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=fbd04e9a&scoped=true"
import script from "./marquee.vue?vue&type=script&lang=js"
export * from "./marquee.vue?vue&type=script&lang=js"
import style0 from "./marquee.vue?vue&type=style&index=0&id=fbd04e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd04e9a",
  null
  
)

export default component.exports